export function IsNullOrEmpty(str) {
    return (str === "" || str === null || str === undefined || str === "undefined" || str === "0" || str === 0)
}